import React, { useEffect, useState } from 'react';
import { useIntersectionObserver } from 'react-intersection-observer-hook';

import SectionTitle from 'components/directus/section-title/SectionTitle';
import sectionTitleHook from 'hooks/section-title/section-title.hook';

import { getFieldBySlug } from 'utils/directus/get-field-by-slug/get-field-by-slug';

import caseStudyHook from 'hooks/case-study/case-study.hook';
import { Props } from './CaseStudyVideo.interface';

import { caseStudyVideo__video } from './CaseStudyVideo.scss';

export default ({ slug }: Props): JSX.Element => {
  const [paused, setPaused] = useState<boolean>(false);
  const [ref, { entry }] = useIntersectionObserver();
  const isVisible = entry && entry.isIntersecting;

  const { node: CaseStudy } = getFieldBySlug(slug, caseStudyHook());
  const { node } = getFieldBySlug('chalk-chillie-case-study-video', sectionTitleHook());

  useEffect(() => {
    if (entry) {
      const player = entry.target as HTMLVideoElement;
      player.volume = 0.5;
      if (isVisible && !paused) {
        player.play();
      } else {
        player.pause();
      }
    }
  }, [isVisible]);

  return (
    <>
      <SectionTitle title={node.heading} subtitle={node.subheading} align="center" />
      <div className={caseStudyVideo__video}>
        <video
          controls
          crossOrigin="anonymous"
          preload="auto"
          muted
          loop
          ref={ref}
          onPause={() => setPaused(isVisible)}
          poster={CaseStudy.video_banner.data.full_url}
        >
          <track
            kind="captions"
            src="https://sp-rapid.s3.eu-west-2.amazonaws.com/videos/case_study_caption_auto-generated.vtt"
          />
          <source src={CaseStudy.video_link} type="video/mp4" />
        </video>
      </div>
    </>
  );
};
